import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3dd44ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descripción", -1 /* HOISTED */))
const _hoisted_2 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        style: {"resize":"none"},
        onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        onDblclick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        id: "w3review",
        name: "msgText",
        rows: "2",
        cols: "50",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedText) = $event)),
        class: "flex justify-content-center p-dropdown p-component p-inputwrapper p-inputwrapper-focus p-overlay-open w-full"
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
        [_vModelText, _ctx.selectedText]
      ]),
      _createElementVNode("i", {
        onPointerdown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
        onDblclick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
        "aria-hidden": "true",
        class: "fa fa-subscript",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showExpression(_ctx.ConditionNodeConst.VAR_COND_IN, 'Condición')))
      }, null, 32 /* HYDRATE_EVENTS */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}